// Resumo da importação para o toast: "3 plantões importados, 1 evento pulado". O backend
// pula (não duplica) evento já importado e data em que o vínculo já tinha plantão.
export function describeImportResult({ criados = [], pulados = [] }) {
  const importados =
    criados.length === 0
      ? "Nenhum plantão novo importado"
      : criados.length === 1
        ? "1 plantão importado"
        : `${criados.length} plantões importados`;
  if (pulados.length === 0) return importados;
  const puladosTexto =
    pulados.length === 1
      ? "1 evento pulado (já importado ou dia já ocupado no vínculo)"
      : `${pulados.length} eventos pulados (já importados ou dias já ocupados no vínculo)`;
  return `${importados}, ${puladosTexto}`;
}
